(function () {
    'use strict';

    let buttonWidth;
    const standardWidth = 22;

    let scale;

    const primaryButtons = document.querySelectorAll('.atm-button-primary');

    primaryButtons.forEach((primaryButton) => {
        primaryButton.addEventListener('mouseenter', () => {
            buttonWidth = primaryButton.offsetWidth;
            scale = Math.ceil(buttonWidth / standardWidth) * 1.15;

            const triangleButton =
                primaryButton.querySelector('.button-triangle');

            if (triangleButton) {
                triangleButton.style.setProperty('--scale', scale);
            }

            const atmIcon = primaryButton.querySelector('.atm-icon');

            if (atmIcon) {
                atmIcon.style.setProperty('--scale', scale);
            }
        });
        primaryButton.addEventListener('mouseleave', () => {
            scale = 1;

            const triangleButton =
                primaryButton.querySelector('.button-triangle');

            if (triangleButton) {
                triangleButton.style.setProperty('--scale', scale);
            }

            const atmIcon = primaryButton.querySelector('.atm-icon');

            if (atmIcon) {
                atmIcon.style.setProperty('--scale', scale);
            }
        });
    });
})();
